import { PaymentDataComponent } from './PaymentData';
import { connect } from 'react-redux';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state: any) => ({});
const mapDispatchToProps = {};

export const PaymentDataStep = connect(mapStateToProps, mapDispatchToProps)(PaymentDataComponent);
